/* istanbul ignore file */
const HB = () => {
  let instance;

  if (typeof window !== 'undefined') {
    // eslint-disable-next-line
    instance = require('honeybadger-js');

    instance.configure({
      apiKey: 'd112af54',
      environment: process.env.NODE_ENV,
      disabled: process.env.NODE_ENV === 'development',
      onerror: process.env.NODE_ENV !== 'development',
      async: true,
      debug: process.env.NODE_ENV === 'development',
    });

    instance.beforeNotify(notice => {
      notice.name = global.appConfig?.name;
    });
  }

  return instance;
};
export default new HB();
